export class CreateProductRequestModel {
  executorId: string;
  categoryId: string;
  type: string;
  name: string;
  calc: string;
  size: number;
  imageUrl: string;
  uniqueCode: string;
}
